import { PaymentMessage } from 'src/devices/payment/dtos/eps-data';
import { showEftInfo } from './show-eft-info';

export const processCashback = async (purchaseResponse: PaymentMessage): Promise<void> => {
  if (
    purchaseResponse?.amounts?.cashbackAmount &&
    purchaseResponse?.amounts?.cashbackAmountApproved &&
    purchaseResponse.amounts.cashbackAmount > purchaseResponse.amounts.cashbackAmountApproved
  ) {
    return showEftInfo(
      'EPS_CashbackApprovedAmountLowerCaption',
      'EPS_CashbackAmountLowerSubmessage',
      'Ok',
      'Cancel',
      {
        arg: purchaseResponse.amounts.cashbackAmount,
        arg2: purchaseResponse.amounts.cashbackAmountApproved,
      },
    );
  }
};
